// extracted by mini-css-extract-plugin
module.exports = {"imported__title":"Imported_imported__title__2GuIi","placeHolderShimmer":"Imported_placeHolderShimmer__19DEh","shimmer":"Imported_shimmer__3BBU5"};